import { useIndexContext } from "../contexts/Index";
import { SortColumns } from "../types";

const useTableHandlers = () => {
    const { sortColumn, setSortColumn, setSortOrder } = useIndexContext();
    const handleHeaderClick = (column: SortColumns) => {
        if (column !== sortColumn) {
            setSortColumn(column);
            setSortOrder("ascending");
        } else {
            setSortOrder(prev =>
                prev === "ascending" ? "descending" : "ascending",
            );
        }
    };

    return { handleHeaderClick };
};

export default useTableHandlers;
